export enum SimBatchStatus {
  UNSET_BATCH_STATUS = 'UNSET_BATCH_STATUS', // Do not use, needed because of proto3 limitations
  PENDING_GENERATION = 'PENDING_GENERATION', // Batch generation in progress
  GENERATED = 'GENERATED', // Batch generation done: Linked to ICCIDs
  PROVISIONED = 'PROVISIONED', // Batch provisioned with SIMs
  ORDERED = 'ORDERED', // TODO: Should be before PROVISIONED -- Provisioning and shipping statuses should be separate
  RECEIVED = 'RECEIVED',
  PROCESSING = 'PROCESSING',
  CLOSED = 'CLOSED',
}
